<template>
    <div
        class="channels-item"
        :class="{
            healthy: isWhatsappChannel && isHealthy,
            dead: isWhatsappChannel && !isHealthy,
        }"
    >
        <div class="first" @click="goToDetail">
            <div @click="goToDetail" class="icon-wrapper">
                <WhatsappBusinessIcon className="channel-icon" v-if="isBusiness" :color="'#FFFFFF'" />
                <WhatsappV1 class="channel-icon" v-if="isV1" :color="'#FFFFFF'" />
                <WhatsappV2 class="channel-icon" v-if="isV2" :color="'#FFFFFF'" />
                <WhatsappV3Icon class="channel-icon" v-if="isV3" :color="'#FFFFFF'" />
                <InstagramIcon class="channel-icon" v-if="isInstagram" special-background-mode />
                <MessengerIcon class="channel-icon" v-if="isMessenger" special-background-mode />
                <img src="/static/img/postacell-logo.png" v-if="smsPostacell" style="max-width: 50px" />
            </div>
            <div
                @click="goToDetail"
                class="channel-name"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    theme: isDarkMode ? 'light-border' : 'google',
                }"
                :content="getChannelType + channel.name.toUpperCase()"
            >
                {{ channel.name }}
            </div>
        </div>
        <div class="actions">
            <IconButton :on-click="() => $router.push(broadcastRequestURL)" v-if="whatsappModal && !isV3">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="$t('wp.broadcast.broadcast')"
                >
                    campaign</span
                >
            </IconButton>
            <a-divider type="vertical" />
            <IconButton :on-click="handleStartChatClick" v-if="whatsappModal">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="'Start Chat'"
                >
                    forum
                </span>
            </IconButton>
            <IconButton :on-click="openQRGenerator" v-if="whatsappModal">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="'QR Oluştur'"
                >
                    qr_code
                </span>
            </IconButton>
            <IconButton :on-click="openSmsModal" v-if="smsModal">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="'SEND SMS'"
                >
                    forum
                </span>
            </IconButton>
            <IconButton :on-click="() => goToContacts()" v-if="this.isInstagram || this.isMessenger">
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="$t('ticimax.members')"
                >
                    group</span
                >
            </IconButton>
            <IconButton
                :on-click="() => goToFilteredTicket()"
                v-if="this.isInstagram || this.isMessenger"
                style="margin-left: 10px"
            >
                <span
                    class="md-icon md-icon-style"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="$t('search.ticket')"
                >
                    confirmation_number</span
                >
            </IconButton>
        </div>

        <a-modal v-model="showModal" :title="$t('tour.startChat')" @ok="closeModal" width="1000px" :footer="null">
            <WhatsappContactList
                :channel="channel"
                :channel-id="channel._id"
                :allowImport="false"
                @close="closeModal"
            />
        </a-modal>
        <a-modal v-model="smsStartChat" :title="$t('tour.startChat')" @ok="closeSmsModal" :footer="null">
            <div class="send-sms-v2">
                <SendSmsInput :default-phone-number="phoneNumber" @sendSMS="sendSMS" />
            </div>
        </a-modal>
        <a-modal
            v-model="qrGeneratorModal"
            :title="$t('message.qrGeneratorModalTitle')"
            @ok="closeQRGeneratorModal"
            :width="1200"
            :footer="null"
            class="qr-generator-modal"
        >
            <div style="height: 700px">
                <iframe
                    style="width: 100%; height: 100%; border: none"
                    :src="qrGeneratorURL"
                    allow="camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation"
                ></iframe>
            </div>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import WhatsappBusinessIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import { mapGetters, mapState } from "vuex";
import IconButton from "../../views/Pages/Settings/components/IconButton.vue";
import WhatsappV2 from "../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import WhatsappV1 from "../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV1.vue";

import { generateUUID } from "../../utils/session";
import { sendSocketMessage } from "../../utils/socketStream";
import WhatsappContactList from "../../views/Pages/IntegrationChannelsItem/WhatsappContactList.vue";
import SendSmsInput from "../../views/Pages/Integrations/SMS/PostaCell/detail/SendSmsInput.vue";
import InstagramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import MessengerIcon from "../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import WhatsappV3Icon from "../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";

export default Vue.extend({
    name: "ChannelStatusItem",
    components: {
        WhatsappV3Icon,
        MessengerIcon,
        InstagramIcon,
        WhatsappV1,
        WhatsappV2,
        IconButton,
        WhatsappBusinessIcon,
        SendSmsInput,
        WhatsappContactList,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
        smsModal: {
            type: Boolean,
            default: false,
        },
        whatsappModal: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            channelInfos: (state) => state.whatsapp.channelInfo,
            site: (state) => state.site.site,
        }),
        getChannelType() {
            if (this.channel.type === "instagram") {
                return this.$t("message.instagramChannel");
            } else if (this.channel.type === "instagram-v2") {
                return "Instagram V2";
            } else if (this.channel.type === "messenger") {
                return this.$t("message.messengerChannel");
            } else if (this.channel.type === "linkedin-unipile") {
                return this.$t("message.linkedinChannel");
            } else if (this.channel.type === "telegram-unipile") {
                return this.$t("message.telegramChannel");
            } else if (this.channel.type === "whatsapp-business-api" || this.channel.type === "whatsapp-business-api-supsis") {
                return this.$t("message.wBChannel");
            } else if (this.channel.type === "whatsapp-qr") {
                return this.$t("message.whatsappv1Channel");
            } else if (this.channel.type === "whatsapp-v2") {
                return this.$t("message.whatsappv2Channel");
            } else if (this.channel.type === "whatsapp-unipile") {
                return this.$t("message.whatsappv3Channel");
            } else if (this.channel.type === "sms-postacell") {
                return this.$t("message.smsChannel");
            }
        },
        isInstagram() {
            return this.channel.type === "instagram" || this.channel.type === "instagram-v2";
        },
        isMessenger() {
            return this.channel.type === "messenger";
        },
        isLinkedin() {
            return this.channel.type === "linkedin-unipile";
        },
        isTelegram() {
            return this.channel.type === "telegram-unipile";
        },
        isBusiness() {
            return this.channel.type === "whatsapp-business-api" || this.channel.type === "whatsapp-business-api-supsis";
        },
        isV3() {
            return this.channel.type === "whatsapp-unipile";
        },
        isV2() {
            return this.channel.type === "whatsapp-v2";
        },
        isV1() {
            return this.channel.type === "whatsapp-qr";
        },
        isWhatsappChannel() {
            return this.isBusiness || this.isV1 || this.isV2 || this.isV3;
        },
        smsPostacell() {
            return this.channel.type === "sms-postacell";
        },
        isHealthy() {
            if (this.isBusiness) {
                // account-deleted veya account-ban ise sağlıksız olarak işaretle
                const onboardReason = this.$_.get(this.channel, "onboard.onboardReason", null);
                if (onboardReason === "account-deleted" || onboardReason === "account-ban") {
                    return false;
                }
                return true;
            } else if (this.isV3) {
                const connectedStates = ["OK", "CREATION_SUCCESS", "RECONNECTED", "SYNC_SUCCESS"];
                const status = this.$_.get(this.channel, "payload.sources.0.status") || this.$_.get(this.channel, "payload.account.sources.0.status");
                return connectedStates.includes(status);
            } else {
                return !!(this.channelInfos[this.channel._id] && this.channelInfos[this.channel._id].status.ready);
            }
        },
        detailURL() {
            if (this.isInstagram) {
                return `/integrations/instagram/${this.channel._id}/detail`;
            } else if (this.isMessenger) {
                return `/integrations/messenger/${this.channel._id}/detail`;
            } else if (this.isLinkedin) {
                return `/integrations/linkedin/${this.channel._id}/detail`;
            } else if (this.isTelegram) {
                return `/integrations/telegram-qr/${this.channel._id}/detail`;
            } else if (this.isBusiness) {
                const isGupshup = this.channel.type === "whatsapp-business-api";
                if (isGupshup) {
                    return `/integrations/whatsapp-business-api/${this.channel._id}/detail`;
                } else {
                    return `/integrations/waba/${this.channel._id}/detail`;
                }
            } else if (this.isV1) {
                return `/integrations/whatsapp-v1/${this.channel._id}/detail`;
            } else if (this.isV2) {
                return `/integrations/whatsapp-v2/${this.channel._id}/detail`;
            } else if (this.isV3) {
                return `/integrations/whatsapp-v3/${this.channel._id}/detail`;
            } else if (this.smsPostacell) {
                return `/integrations/sms/postacell/${this.channel._id}/detail`;
            }
        },
        broadcastRequestURL() {
            const isBusiness = this.channel.type === "whatsapp-business-api";
            const isV1 = this.channel.type === "whatsapp-qr";
            const isV2 = this.channel.type === "whatsapp-v2";
            const smsPostacell = this.channel.type === "sms-postacell";
            if (this.isBusiness) {
                const isGupshup = this.channel.type === "whatsapp-business-api";
                if (isGupshup) {
                    return `/integrations/whatsapp-business-api/${this.channel._id}/detail/broadcast-requests`;
                } else {
                    return `/integrations/waba/${this.channel._id}/detail/broadcast-requests`;
                }
            }
            if (this.isV1) {
                return `/integrations/whatsapp-v1/${this.channel._id}/detail/broadcast-requests`;
            }
            if (this.isV2) {
                return `/integrations/whatsapp-v2/${this.channel._id}/detail/broadcast-requests`;
            }
            if (this.isV3) {
                return `/integrations/whatsapp-v3/${this.channel._id}/detail/broadcast-requests`;
            }
            if (this.smsPostacell) {
                return `/integrations/sms/postacell/${this.channel._id}/detail/postacellAllMessage`;
            }
        },
        color() {
            return this.isHealthy ? "#179d0d" : "red";
        },
        qrGeneratorURL() {
            const phoneNumber = this.channel.payload?.phone || this.channel.payload?.phoneNumber || this.channel.payload?.number || this.channel.payload?.connection_params?.im?.phone_number ||'';
            return `https://qr.supsis.ai?type=qr&number=${encodeURIComponent(phoneNumber)}&message=${encodeURIComponent('Merhaba')}`;
        },
    },
    data() {
        return {
            showModal: false,
            smsStartChat: false,
            phoneNumber: "",
            qrGeneratorModal: false,
        };
    },
    methods: {
        goToFilteredTicket() {
            if (this.isInstagram) {
                this.$router.push({ path: "/ticket", query: { platform: "instagram" } });
            } else {
                this.$router.push({ path: "/ticket", query: { platform: "messenger" } });
            }
        },
        goToContacts() {
            if (this.isInstagram) {
                this.$router.push({ path: "/chat", query: { tab: "instagramContacts" } });
            } else {
                this.$router.push({ path: "/chat", query: { tab: "messengerContacts" } });
            }
        },
        closeModal() {
            this.showModal = false;
            // Modal kapatıldığında dropdown'u da kapat
            this.$emit("close");
        },
        openModal(e) {
            this.showModal = true;
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.$emit("close")
        },
        handleStartChatClick(e) {
            console.log('Start Chat clicked! Önceki değer:', this.showModal);
            this.showModal = true;
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.$nextTick(() => {
                console.log('Start Chat sonrasi değer:', this.showModal);
            });
            // Dropdown'u kapatma, modal açık kalacak
        },
        openSmsModal(e) {
            this.smsStartChat = true;
            e.preventDefault();
            e.stopPropagation();
        },
        closeSmsModal() {
            this.smsStartChat = false;
        },
        openQRGenerator(e) {
            this.qrGeneratorModal = true;
            e.preventDefault();
            e.stopPropagation();
        },
        closeQRGeneratorModal() {
            this.qrGeneratorModal = false;
        },
        goToDetail() {
            if (this.$route.path === this.detailURL) {
                this.$router.push('/chat');
                setTimeout(() => {
                    this.$router.push(this.detailURL);
                }, 10);
            } else {
                this.$router.push(this.detailURL);
            }
        },
        async sendSMS({ text, channelId, senderId, number }) {
            const payload = {
                siteId: this.site._id,
                channelId,
                channelType: "sms-postacell",
                number,
                message: text,
                senderId,
                title: null,
                customMessageId: generateUUID(),
            };
            sendSocketMessage("sms send-single", payload);
        },
    },
});
</script>

<style scoped lang="scss">
.sms-input {
    box-shadow: none !important;
}

.channels-item {
    display: flex;
    justify-content: space-between;
    padding: 4px 8px;
    width: 100%;
    align-items: center;
    border-bottom: none;
    background: #FFFFFF;
    border-radius: 6px;
    margin-bottom: 3px;
    transition: all 0.2s ease;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        background-color: #F8F9FA;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

        .first {
            cursor: pointer;
        }
    }

    .icon-wrapper {
        width: 24px !important;
        height: 24px !important;
        display: flex;
        justify-content: center !important;
        align-items: center !important;
        flex-shrink: 0;
        border-radius: 6px;
        transition: background-color 0.2s ease;

        .channel-icon {
            width: 16px !important;
            height: 16px !important;
        }
    }

    &.healthy .icon-wrapper {
        background-color: #10B981;
    }

    &.dead .icon-wrapper {
        background-color: #EF4444;
    }

    .first {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        flex: 1;
        min-width: 0;
        cursor: pointer;

        .channel-name {
            font-size: 13px;
            font-weight: 500;
            color: #1F2937;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: 3px;
        flex-shrink: 0;
        position: relative;
        z-index: 10;
        pointer-events: auto;

        .md-icon-style {
            font-size: 16px !important;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #6B7280;
            border-radius: 4px;
            transition: all 0.2s ease;
            cursor: pointer;
            pointer-events: auto;

            &:hover {
                background: #F3F4F6;
                color: #4B5563;
            }
        }

        .ant-divider-vertical {
            display: none;
        }

        .icon-button {
            width: 24px !important;
            height: 24px !important;
            padding: 0 !important;
            min-width: 24px !important;
            margin: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            cursor: pointer !important;
            pointer-events: auto !important;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                background: #F3F4F6 !important;
                border-radius: 4px;

                .md-icon-style {
                    color: #4B5563;
                }
            }

            &::before {
                display: none !important;
            }

            .md-ripple {
                display: none !important;
            }
        }
    }
}

.send-sms-v2 {
    margin-left: 38px !important;
}

:global(.qr-generator-modal .ant-modal-body) {
    padding: 0px !important;
}
</style>
